<template>
  <div class="c-dropdown" v-click-outside="onClickOutside">
    <a
      class="c-dropdown__toggle"
      @focus.prevent.stop="onToggleClick"
      tabindex="0"
    >
      <icon width="18" height="18" :name="'dots'"></icon>
    </a>

    <div class="c-dropdown__menu" v-show="menuOpen">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "dropdown",

  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      menuOpen: false
    };
  },

  beforeMount() {
    this.menuOpen = this.isOpen;
  },

  methods: {
    onToggleClick() {
      this.menuOpen = !this.menuOpen;
    },

    onActionClick() {
      //
    },

    onClickOutside() {
      this.menuOpen = false;
    }
  },

  directives: {
    ClickOutside
  }
};
</script>

<style lang="scss">
.c-dropdown {
  position: relative;
  display: block;

  width: 50px;
  height: 50px;

  &__toggle {
    display: block;
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 50px;
    vertical-align: middle;
    cursor: pointer;
    border-radius: 100%;

    background: rgba(0, 0, 0, 0);

    transition: background 0.3s ease;
  }

  &__toggle:hover {
    color: #000;
    background: rgba(0, 0, 0, 0.1);
  }

  &__menu {
    background: $colour-nhs-white;
    border-radius: 4px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
    overflow: hidden;
    min-width: 220px;
    width: auto;
    display: inline-block;

    position: absolute;
    top: 100%;
    margin-top: 1em;
    right: -1em;

    z-index: 25;
  }

  &__action {
    display: block;
    padding: 0 1em;
    height: 54px;
    line-height: 54px;
    color: $colour-nhs-dark-grey;
    text-decoration: none;
    cursor: pointer;
    text-align: right;

    .svg-icon {
      margin-right: 10px;
    }
  }

  &__action:not(:last-of-type) {
    border-bottom: 1px solid $colour-nhs-pale-grey;
  }

  &__action:hover {
    background: #f6f8f8;
    color: $colour-nhs-blue;
  }

  &__action--success:hover {
    color: #0cce4e;
  }

  &__action--danger:hover {
    color: $colour-nhs-emergency-red;
  }
}
</style>
